import { useTranslations } from '@vocab/react';
import { useDispatch } from 'react-redux';

import { ColumnCard } from 'src/components/Card/ColumnCard';
import { LoadingItem } from 'src/components/LoadingBlock/LoadingBlock';
import { PROFILE_VISIBILITY_V2 } from 'src/components/Router';
import { updateRoute } from 'src/components/Router/actionCreators';
import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';
import { useTypedSelector } from 'src/modules/hooks/useTypedSelector';

import { EditProfileVisibility } from '../EditProfileVisibility/EditProfileVisibilityContainer';

import translations from './.vocab';
import { ProfileVisibilityStatus } from './ReadProfileVisibilityStatus';

interface Props {
  loading?: boolean;
}

export const ReadProfileVisibility = ({ loading }: Props) => {
  const { t } = useTranslations(translations);

  const dispatch = useDispatch();
  const mode = useTypedSelector(
    (state) => state.router['profile-visibility-v2'].mode,
  );
  const { profileVisibilityEditLoaded: profileVisibilityEditLoadedAnalytics } =
    useAnalytics();
  const isDrawerOpen = mode === 'EDIT';

  const handleProfileVisibilityEditClicked = () => {
    profileVisibilityEditLoadedAnalytics();
    dispatch(
      updateRoute({
        to: 'profile-visibility-v2',
        mode: 'EDIT',
      }),
    );
  };

  const cardButtonProps = {
    onClick: handleProfileVisibilityEditClicked,
    label: t('Edit visibility'),
  };

  return (
    <>
      <ColumnCard
        name={PROFILE_VISIBILITY_V2}
        title={t('Profile visibility')}
        loader={<LoadingItem type="text" size="standard" width="large" />}
        loading={loading}
        buttonProps={cardButtonProps}
      >
        <ProfileVisibilityStatus loading={loading} />
      </ColumnCard>
      <EditProfileVisibility
        isOpen={isDrawerOpen}
        closeFn={() =>
          dispatch(
            updateRoute({
              to: 'profile-visibility-v2',
              mode: 'READ',
            }),
          )
        }
      />
    </>
  );
};
